import { render, staticRenderFns } from "./ContentsTab.vue?vue&type=template&id=510771b2"
import script from "./ContentsTab.vue?vue&type=script&lang=js"
export * from "./ContentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports